import {Form, Formik} from 'formik';
import FormikTextArea from '../../../../components/formikFileds/textArea';
import CustomButton from '../../../../components/customButton';
import * as Yup from 'yup';
import UseAddCommentAnswer from '../hooks/useAddCommnetAnswer';

type TAnswerCommentProps = {
  setShowAnswer: React.Dispatch<React.SetStateAction<boolean>>;
  commentId: string;
};

interface IََAddComment {
  comment: string;
}
const AddSchema = Yup.object().shape({
  comment: Yup.string().required('عنوان  اجباری می باشد'),
});

const AddAnswerComment = ({setShowAnswer, commentId}: TAnswerCommentProps) => {
  const initialValues: IََAddComment = {
    comment: '',
  };

  const {addAnswer, isLoading} = UseAddCommentAnswer(setShowAnswer);
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={AddSchema}
        onSubmit={values => {
          const payload: IAddCommentAnswerPayload = {
            answer: values.comment,
            comment: commentId,
          };
          addAnswer(payload);
        }}
      >
        {() => (
          <Form noValidate>
            <div className="mt-3">
              <div>
                <FormikTextArea
                  name="comment"
                  label=""
                  rows={4}
                  placeholder="پاسخ خود را بنویسید"
                />
              </div>
            </div>
            <div className="mt-1 d-flex justify-content-end">
              <CustomButton
                outLet={true}
                title="انصراف"
                className="w-25"
                onClick={() => setShowAnswer(false)}
              />
              <CustomButton
                type="submit"
                title="ارسال"
                isLoading={isLoading}
                className="w-25 me-2"
              />
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddAnswerComment;
